export function nextTombolaCommandSequence(
  previousSequence: number,
  now: number = Date.now(),
): number {
  if (
    !Number.isSafeInteger(previousSequence) ||
    previousSequence < 0 ||
    !Number.isSafeInteger(now) ||
    now < 0
  ) {
    throw new Error('Tombola sequence inputs must be non-negative safe integers');
  }
  const sequence = Math.max(now, previousSequence + 1);
  if (!Number.isSafeInteger(sequence)) {
    throw new Error('Tombola command sequence is exhausted');
  }
  return sequence;
}
